import '../../../App.css';
import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';
import Icon from 'carbon-react/esm/components/icon';
import { Tabs, Tab } from 'carbon-react/esm/components/tabs';
import { useNavigate, useParams } from 'react-router-dom';
import ApercuTab from './ApercuTab/ApercuTab';
import BilansTab from './BilansTab/BilansTab';
import PaiementsTab from './PaiementTab/PaiementTab';
import { useQueryDsnDetails } from '../../../hooks/useQueryDsnDetails';
import Loader from 'carbon-react/lib/components/loader/__next__';
import { buildDsnDetails, parseQueryDsnDetailResponse } from '../../../utils/odataResponseHelper';

const TAB_SLUG_TO_ID: Record<string, string> = {
  bilans: 'tab-2',
  paiements: 'tab-3',
};
const TAB_ID_TO_SLUG: Record<string, string> = {
  'tab-2': 'bilans',
  'tab-3': 'paiements',
};
const DEFAULT_TAB_ID = 'tab-1';

export default function DsnDetailsContent() {
  const { instanceId, tab } = useParams<{ instanceId: string; tab?: string }>();
  const navigate = useNavigate();

  const selectedTabId = (tab && TAB_SLUG_TO_ID[tab]) || DEFAULT_TAB_ID;

  const handleTabChange = (tabId: string) => {
    const slug = TAB_ID_TO_SLUG[tabId];
    void navigate(slug ? `/dsn-list/${instanceId}/${slug}` : `/dsn-list/${instanceId}`, {
      replace: true,
    });
  };

  const queryResult = useQueryDsnDetails(instanceId);
  const { data: dsnDetails } = parseQueryDsnDetailResponse(queryResult);

  if (queryResult.isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <Loader size="large" />
      </Box>
    );
  }

  const isDetailsEmpty = !dsnDetails || Object.keys(dsnDetails).length === 0;

  if (isDetailsEmpty) {
    return (
      <Box
        bg="white"
        // maxWidth={600}
        minHeight={250}
        padding="32px"
        gap="5px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        margin="0 auto"
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <span style={{ color: 'var(--colorsSemanticNegative500)' }}>
            <Icon type="error" size="medium" marginBottom="16px" />
          </span>
          <Typography variant="h3" marginBottom="16px">
            La déclaration est introuvable
          </Typography>
        </Box>
      </Box>
    );
  }

  const dsnData = buildDsnDetails(dsnDetails);

  return (
    <Box p="4px">
      <Tabs size="large" position="top" selectedTabId={selectedTabId} onTabChange={handleTabChange}>
        <Tab id="tab-1" label="Aperçu" key="tab-1">
          <ApercuTab data={dsnData} />
        </Tab>

        <Tab id="tab-2" label="Bilans" key="tab-2">
          <BilansTab />
        </Tab>

        <Tab id="tab-3" label="Paiements" key="tab-3">
          <PaiementsTab />
        </Tab>
      </Tabs>
    </Box>
  );
}
